import styled from 'styled-components';

export const SaveGamesWidgetHeaderBox = styled.div`
  align-items: center;
  font-size: 1.4rem;
  display: flex;
  width: 100%;
  color: ${({theme}) => theme.colors.textContrast};

  & span:last-of-type {
    margin-left: auto;
    margin-right: 1rem;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  
  & span:first-of-type {
    margin: 0 1rem;
  }
`;
